import { Suspense } from 'react';
import { YoutubeRecentBroadcastsContent } from './YoutubeRecentBroadcastsContent';
import { YoutubeRecentBroadcastsShell } from './YoutubeRecentBroadcastsShell';
import { Station } from '@app/core/types/stations';

interface YoutubeNativeRecentTransmissionsProps {
  station: Station;
}

/** Recent YouTube Native transmissions panel shown when the station is offline. */
export function YoutubeRecentBroadcasts({ station }: YoutubeNativeRecentTransmissionsProps) {
  return (
    <Suspense fallback={<YoutubeRecentBroadcastsShell loading stationSlug={station.slug} />}>
      <YoutubeRecentBroadcastsContent station={station} />
    </Suspense>
  );
}
